import { Badge, Group, Highlight } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { generatePath } from "react-router";
import { ROUTES } from "../../../../../routes";
import { ObjectUrlName } from "../../../../../utils/enums";
import { AnchorLink } from "../../../../AnchorLink/AnchorLink";
import type {
  FlatLocationOverviewData,
  LocationType
} from "../../LocationOverview.types";

function getLocationColumn(
  globalFilter = ""
): MRT_ColumnDef<FlatLocationOverviewData> {
  return {
    accessorKey: "locationName",
    header: "Lokationen",
    enableGrouping: false,
    size: 350,
    Cell: ({ row }) => {
      const { location } = row.original;
      return (
        <Group gap="sm" wrap="nowrap">
          <LocationName
            componentId={location.id}
            filter={globalFilter}
            name={location.name}
            projectId={location.project}
            siteId={location.site.id}
            type={location.type}
          />
          <Badge
            color={location.status === "aktiv" ? "primary" : "neutral"}
            size="sm"
          >
            {location.status === "aktiv" ? "Aktiv" : "Inaktiv"}
          </Badge>
        </Group>
      );
    }
  };
}

interface LocationNameProps {
  name: string;
  type: LocationType;
  projectId: string;
  siteId: number;
  componentId: number;
  filter?: string;
}

export function LocationName({
  name,
  type,
  projectId,
  siteId,
  componentId,
  filter = ""
}: LocationNameProps) {
  const objectUrlName =
    type.isMarketLocation === true
      ? ObjectUrlName.MarketLocations
      : ObjectUrlName.MeteringLocations;

  const path = generatePath(ROUTES.siteComponentGeneralPage, {
    projectId,
    siteId: siteId.toString(),
    objectUrlName: objectUrlName,
    componentId: componentId.toString()
  });

  return (
    <AnchorLink href={path} target="_self">
      {filter ? <Highlight highlight={filter}>{name}</Highlight> : name}
    </AnchorLink>
  );
}

export { getLocationColumn };
